import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  button {
    background-color: transparent;
    border: none;
  }
  .trashButton {
    font-size: 2rem;
    color: var(--details-color);
  }
`;

export const DeleteModel = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  p {
    text-align: center;
  }
  button {
    margin-top: 1rem;
  }
`;
